export const DARKER_GREY = "#1c2129";
export const DARKER_GREY_ALPHA = "#1c212900";
export const DARK_GREY = "#232933";
export const DARK_GREY_ALPHA = "#23293380";
export const NEW_DARK_GREY = "#2e3135";
export const NEUTRAL_GREY = "#363d47";
export const DARK = "#3F4247";
export const DAT_GREY = "#374252";
export const GREY = "#3e4652";
export const LIGHT_GREY = "#878e99";
export const ALMOST_WHITE = "#c6d1e0";
export const INCREASING_GREEN = "#4ec2ab";
export const INCREASING_GREEN_RGBA = "rgba(78, 194, 171, 0.2)";
export const DECREASING_RED = "#cc4e49";
export const DECREASING_RED_RGBA = "rgba(204, 78, 73, 0.2)";
export const ACCENT_BLUE = "#7a98eb";
export const ACCENT_BLUE_ALPHA = "#6387eb";
export const ACCENT_BLUE_BETA = "#455685";
export const ACCENT_BLUE_RGBA = "rgba(122, 152, 235, 0.2)";
export const RANDOM_BLUE = "#5cd3ff";
export const BACKGROUND_COLOR = "#171a1f";
export const DARK_BACKGROUND_COLOR = "#0c0d0f";
export const LIGTHER_GREY = "#cedaeb";
export const TIMESTAMP_GREY = "#71787a";
export const WHITE = "#ffffff";
export const INDICATOR_BLUE = "#0144e3";
export const TICKER_TEXT_COLOR = "#fafeff";
export const BLACK = "#000000";
export const BLACK_APLHA = "#00000020";
export const LIGHTEST_GRAY = "#a2aab8";
export const BOTICELLI = "#c6d1e0";
export const YELLOW = "#fff202";
export const PURPLE = "#6B54D6";
export const SALMON = "#ED9077";
export const GREEN = "#A3C844";
export const PINK = "#F47CA3";
export const CYAN_BLUE = "#93D5F3";
export const SPUN_PEARL = "#A0A0A3";
export const SHARK = "#1c1d1e";
export const HEATHER = "#bfcdd4";
export const DARK_CORAL = "#5B5F66";
export const GRAY_SALT_SILVER = "#737980";
export const GRAY_CADET_SILVER = "#B8C1CC";
export const GRAY_CADET_SILVER2 = "#B8C1CC";
